module.exports = __webpack_public_path__ + "static/media/0227_Small.8cfe3116.jpg";